import React from 'react';
import { XCircleIcon } from 'lucide-react';
const PAIN_POINTS = ['Tus clases se vacían en invierno y cada año tenés que empezar de cero a buscar nuevos alumnos, perdiendo tiempo y plata en publicidad que no siempre funciona.', 'No sabés cómo promocionarte sin parecer desesperado/a y te sentís incómodo/a cuando tenés que hablar de precios o convencer a alguien para que se inscriba.', 'Pasás horas pensando qué publicar en redes sociales pero tus posteos no atraen nuevos alumnos y parece que hablás al vacío.', 'Tus alumnos te piden descuentos o se van apenas subís los precios, y no sabés cómo hacer entender el verdadero valor de tus clases.'];
export const ProblemSection: React.FC = () => {
  return <section className="py-16 px-4 bg-white" data-id="element-216">
      <div className="container mx-auto max-w-5xl" data-id="element-217">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-218">
          ¿Te suena familiar alguna de estas situaciones?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-219">
          {PAIN_POINTS.map((point, index) => <div key={index} className="bg-red-50 border border-red-100 rounded-2xl p-6 flex items-start gap-4" data-id="element-220">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-221" />
              <p className="text-lg text-gray-800 leading-relaxed" data-id="element-222">{point}</p>
            </div>)}
        </div>
      </div>
    </section>;
};